"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsxs)("defs", {
      children: [(0, _jsxRuntime.jsxs)("linearGradient", {
        id: "prefix__a",
        x1: "5.288%",
        x2: "92.219%",
        y1: "-2.489%",
        y2: "99.564%",
        children: [(0, _jsxRuntime.jsx)("stop", {
          offset: "1%",
          stopColor: "#F8C51B"
        }), (0, _jsxRuntime.jsx)("stop", {
          offset: "100%",
          stopColor: "#E78F24"
        })]
      }), (0, _jsxRuntime.jsxs)("linearGradient", {
        id: "prefix__b",
        x1: "3.142%",
        x2: "95.598%",
        y1: "12.923%",
        y2: "86.077%",
        children: [(0, _jsxRuntime.jsx)("stop", {
          offset: "1%",
          stopColor: "#1E8ACA"
        }), (0, _jsxRuntime.jsx)("stop", {
          offset: "100%",
          stopColor: "#01659E"
        })]
      }), (0, _jsxRuntime.jsxs)("linearGradient", {
        id: "prefix__c",
        x1: "50%",
        x2: "50%",
        y1: "27.771%",
        y2: "97.53%",
        children: [(0, _jsxRuntime.jsx)("stop", {
          offset: "0%",
          stopColor: "#269F49"
        }), (0, _jsxRuntime.jsx)("stop", {
          offset: "100%",
          stopColor: "#008A54"
        })]
      }), (0, _jsxRuntime.jsxs)("linearGradient", {
        id: "prefix__d",
        x1: "43.701%",
        x2: "57.51%",
        y1: "10.015%",
        y2: "91.303%",
        children: [(0, _jsxRuntime.jsx)("stop", {
          offset: "0%",
          stopColor: "#D81F32"
        }), (0, _jsxRuntime.jsx)("stop", {
          offset: "100%",
          stopColor: "#BB2637"
        })]
      })]
    }), (0, _jsxRuntime.jsxs)("g", {
      fillRule: "nonzero",
      fill: "none",
      children: [(0, _jsxRuntime.jsx)("path", {
        fill: "#DC7E28",
        d: "M31.962 13.015v7.562l-1.03 1.028v-7.404z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "url(#prefix__a)",
        d: "M24 3.534h6.932v7.405H24z",
        transform: "translate(0 10.667)"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#FDD600",
        d: "M25.086 13.02L24 14.201h6.932l1.03-1.186z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#90C7EA",
        d: "M16.501 13.344l6.818-.945-.57 1.63-6.725.916z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "url(#prefix__b)",
        d: "M22.749 3.362l.945 6.634-6.724.942-.946-6.66z",
        transform: "translate(0 10.667)"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#0B98D5",
        d: "M22.749 14.029l.945 6.634.515-1.432-.884-6.793-.006-.039"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "url(#prefix__c)",
        d: "M10.742 2.112l6.036 2.717-2.724 6.168L8.018 8.28z",
        transform: "translate(0 10.667)"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#95CEA0",
        d: "M10.115 10.667l.627 2.112 6.036 2.717-.507-2.018z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#69BF6D",
        d: "M10.115 10.667l-2.429 5.752.332 2.528 2.724-6.168z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "url(#prefix__d)",
        d: "M6.748 3.353l.995 6.528-6.672 1.043L0 4.384z",
        transform: "translate(0 10.667)"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#761216",
        d: "M7.204 11.643l.988 6.591-.449 2.314-.995-6.528z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#FFF",
        d: "M29.874 16.867a2.75 2.75 0 00-.608-.925 2.612 2.612 0 00-.866-.591 2.678 2.678 0 00-1.035-.199 2.73 2.73 0 00-1.044.199c-.326.135-.62.336-.864.59a2.68 2.68 0 00-.606.92c-.137.359-.206.74-.202 1.125a3.04 3.04 0 00.204 1.12c.136.35.342.667.604.935.24.251.53.45.852.582.335.134.693.2 1.054.197a2.624 2.624 0 001.903-.779 2.78 2.78 0 00.608-.93 3.155 3.155 0 000-2.244zm-1.424 2.436c-.265.32-.625.48-1.084.48-.46 0-.824-.159-1.091-.477-.268-.32-.398-.757-.402-1.32 0-.574.135-1.02.398-1.34.263-.319.625-.48 1.093-.481.468 0 .82.16 1.085.481.265.322.397.766.397 1.34.004.56-.13.997-.396 1.317zm-22.418.201a.476.476 0 00-.21-.139 1.004 1.004 0 00-.322-.046 2.443 2.443 0 00-.409.04l-1.762.3c.039-.186.11-.364.208-.526a7.21 7.21 0 01.587-.874l.204-.271c.033-.042.08-.103.14-.184.403-.527.653-.956.748-1.293a2.632 2.632 0 00.071-1.145 1.123 1.123 0 00-.092-.307.44.44 0 00-.156-.183.577.577 0 00-.305-.062 2.356 2.356 0 00-.392.039l-2.034.347c-.247.042-.43.114-.545.224a.435.435 0 00-.14.326.6.6 0 00.01.104c.017.16.118.297.264.364.098.04.204.06.31.056.091 0 .182-.01.272-.025l1.705-.287a.902.902 0 01-.052.402c-.05.14-.177.34-.379.597l-.262.326c-.461.554-.791 1.028-.99 1.42a3.097 3.097 0 00-.292.802c-.03.145-.047.292-.048.44 0 .1.008.197.025.294.017.117.051.23.102.337.037.08.098.148.175.194.094.04.196.057.298.05a4.22 4.22 0 00.69-.074l1.848-.313c.328-.056.555-.134.687-.242a.43.43 0 00.16-.345.672.672 0 00-.01-.11.48.48 0 00-.104-.233v-.003zm8.374-4.411a2.553 2.553 0 00-.865-.587 2.604 2.604 0 00-1.016-.212h-.016a2.53 2.53 0 00-1.027.23c-.349.15-.663.37-.924.645a3.48 3.48 0 00-.91 2.14l-.002.13c0 .338.059.673.174.991a2.461 2.461 0 001.423 1.478c.32.139.665.21 1.013.212h.009a2.647 2.647 0 001.026-.22c.35-.156.667-.377.932-.653.273-.29.49-.625.642-.992.159-.363.25-.752.267-1.147v-.11c0-.344-.062-.684-.182-1.006a2.583 2.583 0 00-.544-.897v-.002zm-.661 2.687c-.228.534-.529.9-.9 1.104a1.271 1.271 0 01-.614.162 1.439 1.439 0 01-.568-.123c-.423-.18-.686-.469-.8-.876a1.601 1.601 0 01-.056-.43c.008-.34.086-.675.227-.984.232-.548.536-.92.91-1.125.187-.106.398-.163.614-.164.198.003.394.046.575.126.42.178.682.467.792.876.038.138.057.28.057.423-.003.307-.082.645-.237 1.014v-.003zm7.861-2.484c-.03-.206-.1-.363-.215-.466a.486.486 0 00-.335-.123.694.694 0 00-.103.007.52.52 0 00-.39.24.643.643 0 00-.09.345c.001.054.005.108.014.162l.245 1.726-1.933.283-.245-1.726c-.03-.201-.1-.357-.212-.463a.474.474 0 00-.424-.117.55.55 0 00-.405.237.622.622 0 00-.09.347c0 .055.004.11.012.165l.662 4.49c.03.206.103.362.221.464.096.08.217.122.341.118a.874.874 0 00.114-.008.491.491 0 00.372-.237.654.654 0 00.083-.34c0-.056-.005-.11-.013-.165l-.27-1.773 1.933-.284.27 1.774c.03.203.102.36.22.462a.497.497 0 00.34.123c.035 0 .07-.003.104-.008a.51.51 0 00.386-.237.633.633 0 00.085-.34c0-.055-.004-.11-.013-.165l-.664-4.49z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#EC473F",
        d: "M0 15.051l.132-.657.336-1.674 6.736-1.077-.456 2.377z"
      })]
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Zoho.js.map